module.exports = __webpack_public_path__ + "img/icone-redondo-branco.d34e8250.png";